const AnalyticsStatsCard = ({
  label,
  value,
  icon: Icon,
  iconClassName = "",
}) => {
  return (
    <div className="rounded-lg bg-[#1B416B]/80 px-5 py-5 shadow-lg">
      <div className="flex items-center gap-4">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md">
          <Icon className={`h-7 w-7 ${iconClassName}`} />
        </div>

        <div>
          <p className="text-sm font-semibold text-neutral-100/60">{label}</p>
          <h2 className="mt-1 text-3xl font-bold text-neutral-100">{value}</h2>
        </div>
      </div>
    </div>
  );
};

export default AnalyticsStatsCard;
